import { Component } from '@angular/core';
import { ManuallyUploadedConsultNotesComponent } from '../../../captures/components/manually-uploaded-consult-notes/manually-uploaded-consult-notes.component';

@Component({
    selector: 'app-client-portal-consult-notes',
    templateUrl: './client-portal-consult-notes.component.html',
    imports: [ManuallyUploadedConsultNotesComponent]
})
export class ClientPortalConsultNotesComponent {}
